import { whiteColor } from '../global';

const listAllSeminarsStyle = (theme) => ({
    wrapper: {
        backgroundColor: whiteColor,
    },
    totalNotes: {
        listStyleType: '"※"',
        marginLeft: '-5px',
        paddingLeft: '5px',
    },
    imagePreview: {
        maxWidth: '100%',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: whiteColor,
    },
    thumbnailImage: {
        width: '75px',
        height: '75px',
        borderRadius: '4px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundPosition: 'center center',
    },
    inputTitle: {
        textAlign: 'right',
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    },
    input: {
        width: '100%',
        margin: '10px 0 20px 0',
        [theme.breakpoints.down('md')]: {
            margin: '0 0 20px 0',
        },
    },
    buttonSearch: {
        textAlign: 'right',
        zIndex: 1,
    },
    btnStyle: {
        fontSize: 14,
        minWidth: '100px',
        margin: '10px',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '400px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '300px !important',
            margin: '10px  !important',
        },
    },
    dateRangeSearch: {
        paddingLeft: '8px',
        display: 'flex',
        '& > div': {
            flexGrow: 2,
        },
    },
});

export default listAllSeminarsStyle;
